import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Store } from "sunflower-antd";
import { httpClient, ROOT_URL } from "../App";

export function createCompany(company: Store) {
  return httpClient.post(`${ROOT_URL}/api/v1/companies`, company);
}

export const useGetInfoByUserCode = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: getInfoByUserCode,
  });
};

export function getInfoByUserCode(userCode: number | string) {
  return httpClient.get(`${ROOT_URL}/api/v1/users/code/${userCode}`);
}

export const useCreateCompany = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: createCompanyUser,
  });
};

export function createCompanyUser(company: any): Promise<AxiosResponse<any>> {
  return httpClient.post(`${ROOT_URL}/api/v1/companies/beneficiarie-and-remitter/create`, company);
}

export const useGetDetailCompany = (id: number | null, enabled = true) => {
  return useQuery<{ data: any }>(
    [`/api/v1/companies/:id`, id],
    async () => getDetailCompany(id),
    {
      enabled: enabled && !!id,
    }
  );
};

export function getDetailCompany(id: number | null) {
  return httpClient.get(`${ROOT_URL}/api/v1/companies/${id}`);
}

export const useUpdateCompanyUser = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: updateCompany,
  });
};

export function updateCompany(company: any) {
  return httpClient.patch(`${ROOT_URL}/api/v1/companies/update`, company);
}

export function getListCompanies({
  start,
  end,
  like,
  country,
  userId,
}: {
  start: number;
  end: number;
  like?: string;
  country?: string;
  userId?: number;
}) {
  const params = new URLSearchParams();
  if (start) params.append('_start', String(start));
  if (end) params.append('_end', String(end));
  if (like) params.append('_like', like);
  if (country) params.append('_country', country);
  if (userId) params.append('_userId', String(userId));
  params.append('_isProvider', String(false));
  return httpClient.get(
    `${ROOT_URL}/api/v1/companies?${params.toString()}`
  );
}

export const useGetListCompanies = (params: {
  start: number;
  end: number;
  like?: string;
  country?: string;
  userId?: number;
  enabled?: boolean;
}) => {
  const { enabled = true, ...queryParams } = params;
  return useQuery<{
    data?: any[];
    total?: number;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
  }>(
    [
      '/api/v1/companies',
      queryParams.start,
      queryParams.end,
      queryParams.like,
      queryParams.country,
      queryParams.userId,
    ],
    async () => getListCompanies(queryParams),
    {
      enabled,
    }
  );
};